import React, { useContext } from "react";
import { formatPrice } from "../../helpers/format";
import styles from "../../styles/Leaderboard.module.css";
import TradathonContext from "../../context/tradathon/TradathonContext";
import cryptoContext from "../../context/crypto/cryptoContext";

const Leaderboard = ({ username, netPL, value, rank, id, avatar }) => {
  const { activeRoom } = useContext(TradathonContext);
  const { exchangeRate } = useContext(cryptoContext);
  return (
    <div className={styles.Leaderboard__card}>
      <div className={styles.Leaderboard__card__section1}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={avatar} alt="" className={styles.image} />
          <p>{username}</p>
        </div>

        <p>
          <span>NET P&L</span>{" "}
          <span style={{ color: netPL < 0 ? "#e93847" : "#45aa43" }}>
            {" "}
            {activeRoom?.room.rstatus === 0 ? "NA" : `${netPL} %`}
          </span>
        </p>
        <p>
          <span>Portfolio Value</span>{" "}
          {activeRoom?.room.rstatus === 0
            ? formatPrice(100000 / exchangeRate)
            : formatPrice(value / exchangeRate)}{" "}
          CST
        </p>
      </div>
      <div className={styles.Leaderboard__card__section2}>
        <p className={styles.rank}>{rank}</p>
        {activeRoom._id === id ? <p>My Rank</p> : <></>}
      </div>
    </div>
  );
};

export default Leaderboard;
